import type { InstagramAudioTypeFilter } from './types';

export const INSTAGRAM_AUDIO_TYPE_FILTERS: InstagramAudioTypeFilter[] = [
  'all',
  'music',
  'original_sound',
];

export const DEFAULT_AUDIO_TYPE_FILTER: InstagramAudioTypeFilter = 'all';

export const DEFAULT_AUDIO_VOLUME = 100;

export const DEFAULT_VIDEO_VOLUME = 0;

export const INSTAGRAM_AUDIO_SEARCH_MAX_LENGTH = 255;
